import React from 'react';
import { Users, Leaf, TrendingUp } from 'lucide-react';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import Seo from '../components/Seo'
import('../css/About.css')

const AboutPage = () => {
  return (
    <>
      <Seo
        title="About KhetBazaar"
        description="Learn about KhetBazaar and how we help you buy or lease land across India."
        canonical="https://khetbazaar.in/about"
      />

      <div className="about-page">
        <NavbarComponent />
        <div className="hero-section">
          <div className="overlay"></div>
          <div className="hero-content">
            <h1>Welcome to KhetBazaar</h1>
            <p>Connecting Farmers to Consumers</p>
          </div>
        </div>

        <div className="stats-section">
          <div className="stats-container">
            <div className="stat-card">
              <Users className="icon" />
              <div className="stat-info">
                <h3>10,000+</h3>
                <p>Happy Customers</p>
              </div>
            </div>

            <div className="stat-card">
              <Leaf className="icon" />
              <div className="stat-info">
                <h3>5,000+</h3>
                <p>Farmers Connected</p>
              </div>
            </div>

            <div className="stat-card">
              <TrendingUp className="icon" />
              <div className="stat-info">
                <h3>10,000+</h3>
                <p>Land Listings</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mission-section">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <p>KhetBazaar is revolutionizing agricultural commerce by creating a direct
              bridge between farmers and consumers. We empower farmers with fair prices
              while providing consumers with fresh, quality produce.</p>
          </div>
        </div>

        {/* <div className="contact-section">
        <div className="contact-content">
          <Phone className="icon" />
          <h2>Get in Touch</h2>
          <div className="contact-info">
            <p>Email: info@khetbazaar.com</p>
            <p>Phone: +977-1-XXXXXXX</p>
            <p>Kathmandu, Nepal</p>
          </div>
        </div>
      </div> */}
        <FooterComponent />
      </div>
    </>
  );
};

export default AboutPage;